// src/pages/Hub/lib/opsHubApi.js
//
// Thin client for the Operations Hub aggregator (/api/ops-hub/*).
// REACT_APP_API_BASE_URL already includes /api — never repeat it.

import axios from 'axios';

const BASE = `${process.env.REACT_APP_API_BASE_URL}/ops-hub`;

export const fetchOverview = (range) =>
  axios.get(`${BASE}/overview`, { params: range }).then((r) => r.data);

export const fetchJobs = (params) =>
  axios.get(`${BASE}/jobs`, { params }).then((r) => r.data);

export const fetchMap = (range) =>
  axios.get(`${BASE}/map`, { params: range }).then((r) => r.data);

export const fetchReports = (range) =>
  axios.get(`${BASE}/reports`, { params: range }).then((r) => r.data);

// Item-level drill-down for a single report tile (finance | fsr | attendance | compliance | ehs).
// Phase-B endpoints; callers must tolerate a 404 so the breakdown still renders.
export const fetchReportItems = (kind, params) =>
  axios.get(`${BASE}/reports/${kind}`, { params }).then((r) => r.data);

// One FSR's full detail, dispatched to its region's provider.
export const fetchFsrDetail = (region, id) =>
  axios.get(`${BASE}/reports/fsr/${region}/${id}`).then((r) => r.data);

export const searchAll = (q) =>
  axios.get(`${BASE}/search`, { params: { q } }).then((r) => r.data);
